module.exports = __webpack_public_path__ + "static/media/Invoice.283c6f17.svg";